
define('text!modules/base/templates/subscription.button.template.html',[],function () { return '<div class="btnWrapper">\r\n    <div class="upgradePlan btn btn-primary">Upgrade Subscription Now</div>\r\n</div>';});

